import { useEffect, useState, type ReactNode } from 'react';

const MOBILE_BREAKPOINT = 768;

/** Отслеживает, узкий ли экран (мобильный). Реагирует на resize/поворот. */
function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : false,
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isMobile;
}

/** Полноэкранная заглушка для мобильных: кабинет доступен только на десктопе. */
function MobileStub() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '32px 24px',
        background: '#F9FAFB',
      }}
    >
      <div
        style={{
          fontSize: 28,
          fontWeight: 700,
          letterSpacing: 1,
          color: '#1F2937',
          marginBottom: 24,
        }}
      >
        RICHAT
      </div>
      <h1
        style={{
          fontSize: 20,
          fontWeight: 600,
          color: '#1F2937',
          margin: '0 0 12px',
          lineHeight: 1.4,
        }}
      >
        Кабинет доступен только в десктопной версии
      </h1>
      <p
        style={{
          fontSize: 15,
          color: '#4B5563',
          lineHeight: 1.6,
          maxWidth: 360,
          margin: '0 0 20px',
        }}
      >
        Пожалуйста, откройте RiChat на компьютере — так вы сможете полноценно
        настроить ассистента, загрузить базу знаний и подключить каналы.
      </p>
      <div
        style={{
          fontSize: 14,
          color: '#6B7280',
          padding: '10px 16px',
          background: '#FFFFFF',
          border: '1px solid #E5E7EB',
          borderRadius: 8,
        }}
      >
        Адрес кабинета:{' '}
        <span style={{ fontWeight: 600, color: '#1F2937' }}>cabinet.richat.ru</span>
      </div>
    </div>
  );
}

/**
 * Обёртка: на мобильных экранах (< 768px) показывает заглушку вместо содержимого.
 * На десктопе — обычный контент. Используется в CabinetLayout, чтобы внутренний
 * кабинет был доступен только с компьютера (вход/регистрация — отдельные страницы,
 * не оборачиваются, работают на мобилке).
 */
export function MobileGuard({ children }: { children: ReactNode }) {
  const isMobile = useIsMobile();
  if (isMobile) return <MobileStub />;
  return <>{children}</>;
}
